import { render, staticRenderFns } from "./wechatSubscribeList.vue?vue&type=template&id=cdb2894e&scoped=true"
import script from "./wechatSubscribeList.vue?vue&type=script&lang=js"
export * from "./wechatSubscribeList.vue?vue&type=script&lang=js"
import style0 from "./wechatSubscribeList.vue?vue&type=style&index=0&id=cdb2894e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb2894e",
  null
  
)

export default component.exports